export default "__VITE_ASSET__YdX5N7l3__"